<template>
    <div v-if="user">
        <report-window
            v-if="ready"
            class="agencies-report"
            endpoint="/reports/agencies_servicecost"
            :perPage="500"
            :fields="fields"
            :title="title"
            :headers="headers"
            :templates="templates"
            :hideFilters="options && options.hideFilters"
            :runMounted="options && options.runMounted"
            :cardView="options && options.cardView"
            :current.sync="current" :slotsFields="[]"
            :notFilterable="options && options.notFilterable"
            :hideBlankColumns="false"
            :beforeRender="beforeRender"
            :afterRender="afterRender"
            :columnsClasses="columnsClasses"
            :cellClasses="cellClasses"
            :columnClick="columnClick"
            :hideSearch="true"
            :simpleTable="true"
            :hideToggle="true"
            :hideConfig="true"
            :hideDashboard="true"
            :hideCSV="true"
            :disableSort= "true"
            :columnStyles="{0: { cellWidth: 70} }"
            fileName="Service Rates"
            tableWidth="auto"
            :pdf="true"
            :getFileName="getFileName"
            ref="reportWindow"
            :headerMesssage="headerMesssage"
            @afterEdit="afterEdit"
        ></report-window>
        <service-modal
            v-if="service"
            :s.sync="service"
            :title="serviceTitle"
        ></service-modal>
    </div>
</template>

<script>
import ReportWindow from "@/components/tools/ReportWindow";
const serviceModal = importVueComp('components/reports', 'ServiceModal');
import { mapState } from "vuex";
export default {
    name: "service-costlist-report",
    props: ["options"],
    components: {
        ReportWindow,
        'service-modal': serviceModal,
    },
    computed: {
        ...mapState({
            user: state => state.main.user,
        }),
    },
    async mounted () {
        await frontTools.setReportValues(this);
        this.ready = true;
    },
    data() {
        return {
            current: {},
            service: null,
            serviceTitle: null,
            ready: false,
            costByOptions: {
                  BASE_PERSON: 'Per Person variable',
                  PERSON: 'Per Person, fixed',
                  SERVICE: 'Per Service, fixed',
                  BASE_SERVICE: 'Per Service variable'
            },
            fields: [
                {
                    name: "CityId",
                    relation: "city",
                    optionLabels: "Name",
                    editor: 'vue-select',
                    label: "City",
                    addBlank: true,
                    sort: true,
                },
                {
                    name: "TransDate",
                    editor: "date",
                    label: "Date",
                },
                {
                    name: "MaxBase",
                    editor: "number",
                    decimals: 0,
                        label: "Max. Nbr of Paxs",
                },
                {
                    name: "pageSize",
                    editor: "select", defValue: 'a4',
                    options: [
                        {value: 'a1', label: 'A1'},
                        {value: 'a2', label: 'A2'},
                        {value: 'a3', label: 'A3'},
                        {value: 'a4', label: 'A4'},
                    ]
                },
                {
                    name: "ServiceClassId",
                    relation: "serviceclass",
                    optionLabels: "Name",
                    editor: "vue-select",
                    addBlank: true,
                    label: "Service Class",
                }
            ],
            title: "Service Rates",
            headers: {
                StartDate: "Start Date",
                ServiceName: "Service",
                ServiceType: "Type",
                CurrencyId: "Currency",
                ServiceCategory: "Category",
                Comment: "Comments",
                ADT: 'SIB',
                StartDate: 'Valid From',
                EndDate: 'Valid To'
            },
            templates: [
                {
                    name: "StartDate",
                    callback: (row) => {
                        if (!row.StartDate) return "";
                        return moment(row.StartDate).format("DD/MM/YYYY");
                    }
                },
                {
                    name: "EndDate",
                    callback: (row) => {
                        if (!row.EndDate) return "";
                        return moment(row.EndDate).format("DD/MM/YYYY");
                    }
                },
                {
                    name: 'Amount', callback: (row) => {
                        return tools.toNumber(row.Amount, 0, row.CurrencyId);
                    },
                },
            ],
            columnsClasses: {
                ServiceName: 'cursor-pointer headcol headcol-1',
                ServiceType: 'headcol-2',
                StartDate: 'set-color headcol-3',
                EndDate: 'set-color headcol-4',
                ServiceCategory: 'nowrap',
            },
            columnClick: {
                ServiceName: this.showService,
                StartDate: this.changeColor,
                EndDate: this.changeColor,
            },
            cellClasses: {
                ServiceName: [{
                    class: 'not-visible',
                    condition: row => row.notVisible,
                }],
                ServiceType: [{
                    class: 'not-visible',
                    condition: row => row.notVisible,
                }],
            },
            headerMesssage: {
                colspan: 16,
                html: false,
                rows: [
                ]
            }
        };
    },
    methods: {
        async beforeRender (report) {
            let headers = ['BlackOut', 'ChildDiscount', 'Closed', 'Comment', 'Cost', 'CreatedUTC', 'CreatedUserId', 'PeriodName',
              'CurrencyId', 'Data', 'EndDate', 'StartDate', 'ModifiedUTC', 'ModifiedUserId', 'Service',
              'ServiceCategory', 'ServiceId', 'ServiceName', 'ServiceType', 'id', 'syncVersion', 'Days', 'CurrencyId'];
            if (report.serverColumnsHeader) {
                for (let column of report.serverColumnsHeader) {
                    if (headers.indexOf(column) == -1) {
                        let f = _.find(this.templates, (r) => r.name == column);
                        if (!f) {
                            this.templates.push({
                                name: column, callback: (row) => {
                                    console.log(tools.toNumber(row[column], 0, row.CurrencyId), tools.toNumber(row[column], 0, row.CurrencyId).toString().length);
                                    return tools.toNumber(row[column], 0, row.CurrencyId);
                                }
                            })
                            this.columnsClasses[column] = 'text-right';
                        }
                    }
                }
                this.templates = Object.assign([], this.templates);
                this.columnsClasses = Object.assign({}, this.columnsClasses);
                this.removeColumn(report, 'Comment');
                this.removeColumn(report, 'StartDate');
                this.removeColumn(report, 'EndDate');
                //this.removeColumn(report, 'ADT');
                //this.removeColumn(report, 'CHD');
                report.serverColumnsHeader.splice(2, 0, 'StartDate')
                report.serverColumnsHeader.splice(3, 0, 'EndDate')
                //report.serverColumnsHeader.splice(5, 0, 'ADT')
                this.headerMesssage.colspan = report.serverColumnsHeader.length;
                this.headerMesssage = Object.assign({}, this.headerMesssage);
                if (this.current.CityId) {
                    let city = await api.get('/api/city/' + this.current.CityId)
                    if (city && city.ServicesMessage && city.ServicesMessage.length>20) {
                        this.headerMesssage = Object.assign({}, {
                            html: city.ServicesMessage,
                            colspan: report.serverColumnsHeader.length
                        });
                    }
                }
                //report.serverColumnsHeader.splice(6, 0, 'CHD')
            }
            for (let i in report.list) {
                let row = report.list[i];
                row.rowSpan = {};
                if (!row.notVisible) {
                    let rowSpan = _.filter(report.list, (r) => {
                        return r.SupplierId == row.SupplierId && r.ServiceName == row.ServiceName && r.ServiceType == row.ServiceType;
                    }).length;
                    row.rowSpan.ServiceName = rowSpan;
                    row.rowSpan.ServiceType = rowSpan;
                }
                if (!row.notVisible2) {
                    let rowSpan = _.filter(report.list, (r) => {
                        return r.SupplierId == row.SupplierId;
                    }).length;
                    row.rowSpan.SupplierName = rowSpan;
                }
            }

        },
        removeColumn (report, column) {
            var index = report.serverColumnsHeader.indexOf(column);
                if (index !== -1) {
                report.serverColumnsHeader.splice(index, 1);
            }
        },
        afterRender (report) {
            let colst = $('#simpleTable > thead > tr > .headcol')
            let lastCol;
            let sum = 0
            for (let i=0; i<colst.length; i++) {
                let col = colst[i];
                let headCol = `.headcol-${i+1}`
                if (lastCol) {
                    let $col = $(lastCol);
                    let cssWidth = $col.css('width');
                    let jqueryWidth = $col.width();
                    sum += parseInt(jqueryWidth)
                    $(headCol).css('left', sum + 'px')
                }
                lastCol = col;
            }
        },
        async showService (row, report) {
            let s = await api.get('/api/service/' + row.ServiceId);
            if (s) {
                this.service = s;
                this.serviceTitle = row.ServiceName;
            }
        },
        getFileName (type) {
            if (this.current.CityId) {
                let city = _.find(api.tables.city, (r) => r.id == this.current.CityId);
                if (city) return `${city.Name}.${type}`;
            }
            return `Service Rates.${type}`;
        },
        changeColor (row, report) {
            let value = 'bg-warning';
            if (!row.class) row.class = '';
            if (row.class.includes(value)) {
                row.class = row.class.replace(value, '');
            } else if (!row.class.includes(value)) {
                row.class += ' ' + value;
            }
            report.dataList = Object.assign([], report.dataList);
        },
        async afterEdit (fieldName) {
            if (fieldName=='CityId' && this.current.CityId) {
                let city = await api.get('/api/city/' + this.current.CityId)
                if (city && city.ServicesMessage && city.ServicesMessage.length>20) {
                    this.headerMesssage = Object.assign({}, {
                        html: city.ServicesMessage
                    });
                }
            }


        }
    }
};
</script>

<style>
.bg-warning .set-color {
    background-color: #ffc107!important;
}
.white-space-nowrap {
    white-space: nowrap;
}
#simpleTable p {
    margin-bottom: 0 !important;
}
</style>